<!--
// app/components/Shared/news/CardNewsArticle.vue
-->
<script setup lang="ts">
import type { Post } from "~/src/post/domain/models/Post";
import type { DateTimeFormatOptions } from "@intlify/core-base";
import postUiService from "~/src/post/infrastructure/ui-services/postUiService";
import { setAliasUrl } from "~/src/Shared/utils";
import ByExternalMedia from "~/app/components/Shared/news/ByExternalMedia.vue";

type Props = {
  post: Post;
  isPostSlider?: boolean;
};

defineProps<Props>();

const localePath = useLocalePath();
const { locale } = useI18n();
const route = useRoute();
const { isExternal } = postUiService();

const dateOptions: DateTimeFormatOptions = {
  month: "long",
  day: "numeric",
  year: "numeric",
};
</script>

<template>
  <div
    class="border rounded-lg shadow bg-gray-900 border-gray-900 m-2.5"
    :class="{ 'min-w-[265px] md:min-w-[430px]': isPostSlider }"
  >
    <NuxtLink
      :to="
        isExternal(post.categories)
          ? post.acf.external_url
          : localePath({
              name: 'region-news-post',
              params: { region: route.params.region, news: $t('general.news.word'), post: post.slug },
            })
      "
      :target="post.target"
      class="relative block"
    >
      <div v-for="(image, index) in post.seoHeadJSON.og_image" :key="index">
        <NuxtImg
          v-if="index === 0 && !!image?.url"
          class="rounded-t-lg object-cover h-56 w-full"
          :src="setAliasUrl(image.url)"
          alt=""
          :width="image.width"
          :height="image.height"
          sizes="298px sm:383px md:490px lg:458px"
        />
        <by-external-media
          class="absolute bottom-1 left-3"
          v-if="isExternal(post.categories) && !!post.acf.external_logo_url"
          :logo_url="post.acf.external_logo_url"
        />
      </div>
    </NuxtLink>
    <NuxtLink
      :to="
        isExternal(post.categories)
          ? post.acf.external_url
          : localePath({
              name: 'region-news-post',
              params: { region: route.params.region, news: $t('general.news.word'), post: post.slug },
            })
      "
    >
      <div class="p-3 max-w-xs">
        <p class="mb-2 text-xs font-normal text-gray-400 uppercase">
          {{ new Date(post.dateGmt).toLocaleDateString(locale, dateOptions) }}
        </p>
        <p class="mb-2 text-base tracking-tight text-gray-200" v-html="post.title"></p>
      </div>
    </NuxtLink>
  </div>
</template>

<style scoped></style>
